import React, { ReactElement, useEffect, useState } from 'react'

import { Icon } from '@app/components/util'

import { ICON_NAME } from '@app/constants/icon'

import styles from './styles.module.scss'

import type { GetTextsFn, RecommendationRendererProps } from './types'

const DEFAULT_TEXT = 'Весь ассортимент'

export const RecommendationRenderer: React.FC<RecommendationRendererProps> = ({ recommendation }): ReactElement => {
  const [recommendationText, setRecommendationText] = useState('')

  useEffect(() => {
    const getRecommendationTextFragment: GetTextsFn = (prefix, recommendationKey) => {
      const recommendationValue = recommendation?.[recommendationKey]

      if (!recommendationValue) return ''

      return `${prefix}: ${recommendationValue.map(item => item.name).join(', ')}`
    }

    const handleRecommendationText = (): void => {
      if (recommendation) {
        const purchasingGroupsText = getRecommendationTextFragment('Группа закупок', 'purchasingGroups')
        const commodityGroupsText = getRecommendationTextFragment('Товарная группа', 'commodityGroups')
        const categoriesText = getRecommendationTextFragment('Категория', 'categories')
        const subcategories = getRecommendationTextFragment('Подкатегория', 'subcategories')
        const trendsText = getRecommendationTextFragment('Направление', 'trends')

        const recommendationTexts = [
          purchasingGroupsText,
          commodityGroupsText,
          categoriesText,
          subcategories,
          trendsText
        ].filter(item => item.length)

        return setRecommendationText(recommendationTexts.join(', '))
      }

      setRecommendationText(DEFAULT_TEXT)
    }

    handleRecommendationText()
  }, [recommendation])

  return (
    <div className={ styles.recommendationRenderer }>
      <span className={ styles.recommendationRenderer__text }>{ recommendationText }</span>
      <Icon
        name={ ICON_NAME.edit }
        size='20px'
      />
    </div>
  )
}
